<script>
  import { windowInnerWidth, windowInnerHeight } from "$lib/stores/dimensions.js";
  import { onMount } from "svelte";
  import { getJson, contains, setColour } from "$lib/helpers/toolbelt.js";
  import Tag from "$lib/components/Tag.svelte";

  let electorates = [];
  let currentProfile = null;
  let selectedElectorate = [114];
  let keys = [
    "Age",
    "Income",
    "Education",
    "Homeowners",
    "Renters",
    "Referendum",
    "English",
    "Bulk"
  ];

  const partyColour = (party) => {
    const partyColours = {
      ALP: "#b51800",
      NAT: "#197caa",
      GRN: "#298422",
      IND: "purple",
      ON: "on",
      UAP: "uap",
      KAP: "#ff9b0b",
      XEN: "xen",
      CA: "#e6711b",
      LIB: "#005689",
      LNP: "#005689",
    };
    return partyColours[party] ? partyColours[party] : "pink";
  };


  const loadData = async () => {
    const json = await getJson(
      "https://interactive.guim.co.uk/docsdata/1CSIEXnwiw4vSIjU1RGkrjX5SDTWQKR8NvTdtbkS6Zhg.json"
     // "https://interactive.guim.co.uk/docsdata/1KCYiJLkU6GKHEm9mfK6q8H5vzw2TpNU5mJLkJ9nRAWI.json"
    );

    // initialize active state for all electorates
    json.sheets.Sheet1.forEach((element) => {
      element.active = false;
    });

    // filter electorates and update the list
    electorates = json.sheets.Sheet1.filter((d) =>
      contains(selectedElectorate, +d.id)
    );

    // load the first electorate's data by default
    loadElectorateData(electorates[0].id);
  };

  onMount(async () => {
    // Parse the URL for a query parameter named "ids"
    const params = new URLSearchParams(window.location.search);
    const idsParam = params.get("ids");
    if (idsParam) {
      const parsedIds = idsParam
        .split(",")
        .map(id => parseInt(id, 10))
        .filter(Number.isFinite);
      // Use only the first 5 IDs if more than 5 are provided
      selectedElectorate = parsedIds.slice(0, 5);
      await loadData();
    } else {
      selectedElectorate = [114];
      await loadData();
    }
    
  });

  const loadElectorateData = async (id) => {

    // update active property for each electorate
    electorates.forEach((element) => {
      element.active = element.id === id;
    });

    // reassign to trigger Svelte reactivity
    electorates = [...electorates];

    // load the profile data for the selected electorate
    currentProfile = electorates.find(d => d.id === id)
    
  };

  /**
  ** id
  ** electorate
  ** party
  ** marginText
  ** copy
  ** factoids
  */

</script>

<svelte:window
  bind:innerWidth={$windowInnerWidth}
  bind:innerHeight={$windowInnerHeight}
/>

<div class="profile">
  <div class="button_container">
    {#if electorates.length > 1}
    {#each electorates as electorate (electorate.id)}
      <Tag
        label={electorate.electorate}
        active={electorate.active}
        on:click={() => loadElectorateData(electorate.id)}
        colour="black"
        activeColour={partyColour(electorate.party)}
        activeText="white"
      />
    {/each}
    {/if}
  </div>

  {#if currentProfile}
    <div class="profile_info electorate-details {setColour(currentProfile.party)}">
      <div
        class="map"
        style="background-image: url(https://interactive.guim.co.uk/embed/2025/03/election/maps/{currentProfile.id}.png)"
      >
        <img
          src="https://interactive.guim.co.uk/embed/2025/03/election/maps/{currentProfile.id}.svg"
          alt="Map"
        />
      </div>

      
      <div class="blurbs">
        <h2 style="color:{partyColour(currentProfile.party)};">{currentProfile.electorate}</h2>

        <div class="text_wrap">
          <p>{@html currentProfile.marginText}</p>
          <p>{currentProfile.copy}</p>
          {@html currentProfile.factoids}
        </div>
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  .profile {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background-color: white;
  }

  .button_container {
    width: 100%;
    display: flex;
    margin-bottom: 10px;;
  }

  button {
    margin-right: 10px;
  }

  .map {
    background-size: cover;
    border-radius: 1px;
    
    @include mq($until: mobileLandscape) {
      width: 100%;;
      height: 0px;
      padding-bottom: 100%;
      margin-bottom: 10px;
      margin-top: 10px;
    }
    
    @include mq($from: mobileLandscape) {
      width: 300px;
      height: 300px;
      float: left;
      margin-right: 10px;
    }


    img {
      width: 100%;
      height: auto;
    }
  }

  .profile_info {
    width: 100%;
    max-width: 1300px;


    .blurbs {
      

      @include mq($until: mobileLandscape) {
        width:100%;
      }
      
      @include mq($from: mobileLandscape) {
        width: calc(100% - 320px);
        display: flex;
        flex-direction: column;
        float: right;
        display: flex;
      }

      .text_wrap {
        
        @include mq($from: tablet) {
          columns: 2;
        }
      }

    }

    p {
      max-width: 100%;
    }
  }

  h2 {
    @include f-headline();
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
  }
</style>
